<script>
import {
  defineComponent, computed,
} from '@vue/composition-api';

import SellersHeader from '../components/Sellers/SellersHeader.vue';
import SellerList from '../components/Sellers/SellersList.vue';
import Loader from '../components/Loader.vue';

export default defineComponent({
  components: {
    SellerList,
    SellersHeader,
    Loader,
  },
  setup(props, { root }) {
    const profile = computed(() => root.$store.getters.getProfile);
    return {
      profile,
    };
  },
});
</script>

<template>
  <v-container
    class="sellers mt-3 px-4"
    style="min-height: 100vh"
  >
    <div v-if="profile && profile.name">
      <SellersHeader />
      <SellerList />
    </div>
    <div
      v-else
      class="ma-2"
    >
      <Loader />
    </div>
  </v-container>
</template>

<style lang="scss" scoped>
.sellers {
  margin-bottom: 60pt;
}
</style>
